import type {
  DeliveryByEventDisplayName,
  DeliveryByEventDisplayNames,
  DeliveryByEventName,
} from '@noths/polaris-dev-ts-types';

const DELIVERY_EVENT: DeliveryByEventDisplayNames = {
  easter: {
    prefix: 'Get',
    name: 'Easter',
  },
  fathers_day: {
    prefix: 'Get',
    name: "Father's day",
  },
  halloween: {
    prefix: 'Get',
    name: 'Halloween',
  },
  mothers_day: {
    prefix: 'Get',
    name: "Mother's day",
  },
  valentines_day: {
    prefix: 'Get',
    name: "Valentine's day",
  },
  christmas: {
    prefix: 'Arrives',
    name: 'Christmas',
  },
};

export const getDeliveryByEventName = (
  deliveryEvent: DeliveryByEventName,
): DeliveryByEventDisplayName => DELIVERY_EVENT[deliveryEvent];

export const getDeliveryByEventLabel = (deliveryEvent: DeliveryByEventName): string => {
  const eventDetails = getDeliveryByEventName(deliveryEvent);

  return eventDetails ? `${eventDetails.prefix} by ${eventDetails.name}` : '';
};
